import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import i18n from './i18n';
import ElementUI from 'element-ui';
import { Viewport } from './plugins/viewport';
import plugins from './plugins'; // plugins
import VueLazyLoad from 'vue-lazyload';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/index.scss'; // global css

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Viewport);
Vue.use(VueLazyLoad, {
  preLoad: 1,
  error: require('./assets/img/jzsb2.png'), // 错误图片
  loading: require('./assets/img/jzz.gif'), // 加载中图片
  attempt: 3,
});
Vue.use(plugins);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
